import React from "react";
import {
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

export type SelectOption = {
  shc: string;
  nam: string;
};

type Props = {
  label: string;
  value?: string | null;
  options: SelectOption[];
  allLabel?: string;
  disabled?: boolean;
  minWidth?: number;
  //onChange: (value: string | null) => void;
  onChange: (e:any) => void;
};

export default function ClearableSelectField({
  label,
  value,
  options,
  allLabel = "All",
  disabled = false,
  minWidth = 170,
  onChange,
}: Props) {
  const hasValue = value !== null && value !== undefined && value !== "";

  return (
    <TextField
      select
      //size="small"
      label={label}
      value={value ?? ""}
      disabled={disabled}
      sx={{ minWidth }}
      //onChange={(e) => onChange(e.target.value || null)}
      onChange={onChange}
      slotProps={{
        input: {
          endAdornment: hasValue ? (
            <InputAdornment position="end" sx={{ mr: 2.5 }}>
              <IconButton
                size="small"
                edge="end"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  //onChange(null);
                  onChange({target:{value:null}})
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        }
      }}
    >
      <MenuItem value="">{allLabel}</MenuItem>

      {options.map((x) => (
        <MenuItem key={x.shc} value={x.shc}>
          {x.nam}
        </MenuItem>
      ))}
    </TextField>
  );
}